import React from 'react'

function Other_part() {
  return (
    <div className='others_div'>
      <div className='big_conts'>
        <div>
        
        <div><p className='coming_soon'>Coming Soon...</p></div>
        </div>
      </div>
   
      
    </div>
  )
}

export default Other_part
